import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

interface MarketSizeChartProps {
  tam: number;
  sam: number;
  som: number;
  currency: string;
  type: "money" | "customers";
}

export const MarketSizeChart = ({ tam, sam, som, currency, type }: MarketSizeChartProps) => {
  const data = [
    { name: "TAM", value: tam, color: "#1E3A8A" },
    { name: "SAM", value: sam, color: "#3B82F6" },
    { name: "SOM", value: som, color: "#93C5FD" },
  ].filter((item) => item.value > 0);

  const formatValue = (value: number) => {
    if (type === "money") {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(value);
    } else {
      return new Intl.NumberFormat('en-GB', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(value);
    }
  };

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value: number) => formatValue(value)}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};